import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "message/hotel/";

class CommunicationService {
  getConversations({
    filter = "all",
    search = "",
    page = 1,
    limit = 30,
    signal,
  } = {}) {
    return axios.get(ENDPOINT_URL + "conversations", {
      params: { filter, search, page, limit },
      headers: authHeader(),
      signal,
    });
  }

  getConversationStaff() {
    return axios.get(ENDPOINT_URL + "staff", { headers: authHeader() });
  }

  notifyStaff(bookingId, target, message, photo) {
    let payload = { target, message };
    if (photo) {
      payload = new FormData();
      payload.append("target", JSON.stringify(target));
      payload.append("message", message || "");
      payload.append("file", photo);
    }
    return axios.post(
      ENDPOINT_URL + bookingId + "/notify-staff",
      payload,
      { headers: authHeader() },
    );
  }

  draftReply(bookingId) {
    return axios.post(ENDPOINT_URL + bookingId + "/draft-reply", {}, { headers: authHeader() });
  }

  handoffToAi(bookingId) {
    return axios.post(
      ENDPOINT_URL + bookingId + "/handoff-to-ai",
      {},
      { headers: authHeader() },
    );
  }

  getMessages(bookingId, cursorMessageId, bookingIds) {
    return axios.post(
      ENDPOINT_URL + "list/" + bookingId,
      { cursorMessageId, bookingIds },
      { headers: authHeader() },
    );
  }

  sendMessage(bookingId, message, options = {}) {
    const { forceSms, photo } = options;
    let payload = { message, forceSms: !!forceSms };
    if (photo) {
      payload = new FormData();
      payload.append("message", message || "");
      payload.append("forceSms", String(!!forceSms));
      payload.append("file", photo);
    }
    return axios.post(
      ENDPOINT_URL + bookingId,
      payload,
      { headers: authHeader() },
    );
  }

  markAsRead(messageId) {
    return axios.get(ENDPOINT_URL + messageId + "/read", {
      headers: authHeader(),
    });
  }

  getAIMessages(cursorMessageId, testAsGuest = false) {
    return axios.post(
      ENDPOINT_URL + "list/ai",
      { cursorMessageId, testAsGuest },
      { headers: authHeader() },
    );
  }

  sendAIMessage(message, testAsGuest, screenshot, currentPath, language = "en") {
    const formData = new FormData();
    formData.append("message", message || "");
    formData.append("language", language);
    formData.append("testAsGuest", String(Boolean(testAsGuest)));
    formData.append("currentPath", currentPath || window.location.pathname);
    if (screenshot) formData.append("file", screenshot);
    return axios.post(ENDPOINT_URL + "ai", formData, { headers: authHeader() });
  }

  getAIScreenshot(filename) {
    return axios.get(API_URL + "image/s4h/" + encodeURIComponent(filename), {
      headers: authHeader(),
      responseType: "blob",
    });
  }

  sendSupportReply(hotelId, text, screenshot) {
    const formData = new FormData();
    formData.append("text", text || "");
    if (screenshot) formData.append("file", screenshot);
    return axios.post(
      API_URL + "support/hotels/" + encodeURIComponent(hotelId) + "/messages",
      formData,
      { headers: authHeader() },
    );
  }

  sendSupportEmail(messageText) {
    return axios.post(
      ENDPOINT_URL + "support",
      { messageText },
      { headers: authHeader() },
    );
  }
}

export default new CommunicationService();
